import { getDataClient } from "@/lib/dataClient";
import { useDataQuery } from "@/hooks/useDataQuery";

export interface TeacherStats {
  studentCount: number;
  courseCount: number;
  liveClassCount: number;
  homeworkCount: number;
}

/**
 * Öğretmen ana panelindeki özet istatistikleri dataClient'den çeker.
 * Tablolar henüz boşsa 0 değerleri döner; içerik eklendikçe canlı güncellenir.
 */
export function useTeacherStats() {
  return useDataQuery<TeacherStats>(async () => {
    const dataClient = getDataClient();

    const [students, courses, liveClasses, homeworks] = await Promise.all([
      dataClient.from("profiles").select("id", { count: "exact", head: true }).eq("role", "ogrenci"),
      dataClient.from("courses").select("id", { count: "exact", head: true }),
      dataClient.from("live_classes").select("id", { count: "exact", head: true }),
      dataClient.from("homework").select("id", { count: "exact", head: true }),
    ]);

    if (students.error) throw students.error;
    if (courses.error) throw courses.error;
    if (liveClasses.error) throw liveClasses.error;
    if (homeworks.error) throw homeworks.error;

    return {
      studentCount: students.count ?? 0,
      courseCount: courses.count ?? 0,
      liveClassCount: liveClasses.count ?? 0,
      homeworkCount: homeworks.count ?? 0,
    };
  });
}